import angular from 'angular';

/**
 * @param {number} n
 * @param {number} prec
 * @returns {string}
 */
const toFixedFix = (n, prec) => {
	const k = 10 ** prec;
	return `${(Math.round(n * k) / k).toFixed(prec)}`;
};

/**
 * @param {number} number
 * @param {number} decimals
 * @param {string} [decPoint]
 * @param {string} [thousandsSeparator]
 * @returns {string}
 */
const numberFormat = (
	number,
	decimals,
	decPoint,
	thousandsSeparator = undefined,
) => {
	//  discuss at: http://phpjs.org/functions/number_format/
	// original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)

	const snumber = (`${number}`).replaceAll(/[^\d+.Ee-]/g, '');

	const n = Number.isFinite(+snumber) ? +snumber : 0;
	const prec = Number.isFinite(+decimals) ? Math.abs(decimals) : 0;
	const separator = (thousandsSeparator === undefined) ? ',' : thousandsSeparator;
	const dec = (decPoint === undefined) ? '.' : decPoint;

	// Fix for IE parseFloat(0.55).toFixed(0) = 0;
	const s = (prec ? toFixedFix(n, prec) : `${Math.round(n)}`).split('.');

	if (s[0].length > 3) {
		s[0] = s[0].replaceAll(/\B(?=(?:\d{3})+(?!\d))/g, separator);
	}

	if ((s[1] || '').length < prec) {
		s[1] = s[1] || '';
		s[1] += Array.from({ length: prec - s[1].length + 1 })
			.join('0');
	}

	return s.join(dec);
};

/**
 * @param {number | undefined} size
 * @returns {any}
 */
const humanSize = size => {
	let unit;
	let stringSize = '';

	if (size === undefined || size === null) {
		return '';
	}

	if (size > 1e12) {
		unit = 'To';
		// eslint-disable-next-line no-param-reassign
		stringSize = numberFormat(size / 1e12, 1, ',', ' ');
	}
	else if (size > 1e9) {
		unit = 'Go';
		stringSize = numberFormat(size / 1e9, 1, ',', ' ');
	}
	else if (size > 1e6) {
		unit = 'Mo';
		stringSize = numberFormat(size / 1e6, 1, ',', ' ');
	}
	else if (size > 1e3) {
		unit = 'Ko';
		stringSize = numberFormat(size / 1e3, 1, ',', ' ');
	}
	else {
		unit = size > 1 ? 'octets' : 'octet';
		stringSize = `${size}`;
	}

	return `${stringSize} ${unit}`;
};

/* @ngInject */
/**
 * @returns {Function}
 */
function humanSizeFilter() {
	return (/** @type {number | undefined} */ size) => humanSize(size);
}

/**
 * @memberOf app
 * @ngdoc filter
 * @name app.filter:humanSize
 * @function
 * @description
 * # humanSize
 * Converts file size numbers to a human-readable string.
 *
 * @example
 *   Usage:
 *   <p>{{ NUMBER | humanSize }}</p>
 *
 *   <p>{{ 135118662 | humanSize }}</p> // returns <p>135,1 Mo</p>
 *
 */
angular.module('app')
	.filter('humanSize', humanSizeFilter);
